var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M47,8.5H28h-1H8c-4.4,0-8,3.6-8,8v6c0,2.208,0.909,4.211,2.369,5.66C3.464,29.247,4,30.779,4,32.322 l0,7.151c0,3.865,3.162,7.027,7.027,7.027H27h1h16.846c3.385,0,6.154-2.769,6.154-6.154V32.55c0-1.69,0.625-3.33,1.791-4.554 C54.157,26.562,55,24.626,55,22.5v-6C55,12.1,51.4,8.5,47,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD490"
    },
    d: "M22.762,8.5H8c-4.4,0-8,3.6-8,8v6c0,2.208,0.909,4.211,2.369,5.66C3.464,29.247,4,30.779,4,32.322 l0,7.151c0,3.865,3.162,7.027,7.027,7.027h7.531c3.543,0,6.442-2.899,6.442-6.442l0-8.203c0-1.406,0.633-2.704,1.631-3.695 C28.091,26.711,29,24.708,29,22.5v-7.762C29,11.307,26.193,8.5,22.762,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#704928"
    },
    d: "M46,30.5h-9c-0.552,0-1-0.447-1-1s0.448-1,1-1h9c0.552,0,1,0.447,1,1S46.552,30.5,46,30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#704928"
    },
    d: "M33,30.5h-2c-0.552,0-1-0.447-1-1s0.448-1,1-1h2c0.552,0,1,0.447,1,1S33.552,30.5,33,30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M9.5,35c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l1.5-1.5 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-1.5,1.5C10.012,34.902,9.756,35,9.5,35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M17.593,27.893c-0.211,0-0.424-0.066-0.605-0.204L15.3,26.403c-0.439-0.335-0.524-0.962-0.189-1.401 c0.334-0.439,0.961-0.524,1.401-0.19l1.688,1.285c0.439,0.335,0.524,0.962,0.189,1.401C18.192,27.757,17.895,27.893,17.593,27.893z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M11.999,42.5c-0.211,0-0.424-0.066-0.605-0.204l-1.688-1.285c-0.439-0.335-0.524-0.962-0.189-1.401 c0.334-0.439,0.961-0.525,1.401-0.19l1.688,1.285c0.439,0.335,0.524,0.962,0.189,1.401C12.599,42.364,12.301,42.5,11.999,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M17.139,38.445c-0.431,0-0.829-0.28-0.958-0.715c-0.157-0.529,0.144-1.086,0.673-1.244l2.033-0.604 c0.53-0.15,1.086,0.145,1.244,0.674s-0.144,1.086-0.673,1.244l-2.033,0.604C17.33,38.432,17.233,38.445,17.139,38.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M5.327,17c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l1.5-1.5 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-1.5,1.5C5.839,16.902,5.583,17,5.327,17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M7.826,24.5c-0.211,0-0.424-0.066-0.605-0.204l-1.688-1.285c-0.439-0.335-0.524-0.962-0.189-1.401 c0.334-0.44,0.961-0.525,1.401-0.19l1.688,1.285c0.439,0.335,0.524,0.962,0.189,1.401C8.426,24.364,8.128,24.5,7.826,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M24.019,23.903c-0.479,0-0.903-0.346-0.985-0.834l-0.353-2.092 c-0.092-0.544,0.275-1.061,0.819-1.152c0.549-0.086,1.061,0.275,1.152,0.82l0.353,2.092c0.092,0.544-0.275,1.061-0.819,1.152 C24.13,23.898,24.074,23.903,24.019,23.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M12.966,20.445c-0.431,0-0.829-0.28-0.958-0.715c-0.157-0.529,0.144-1.086,0.673-1.244l2.033-0.604 c0.53-0.155,1.087,0.145,1.244,0.674c0.157,0.529-0.144,1.086-0.673,1.244l-2.033,0.604C13.157,20.432,13.061,20.445,12.966,20.445 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M20.978,16.268c-0.121,0-0.243-0.021-0.362-0.067l-1.978-0.768c-0.515-0.2-0.771-0.779-0.57-1.295 c0.199-0.515,0.779-0.77,1.294-0.57l1.978,0.768c0.515,0.2,0.771,0.779,0.57,1.295C21.756,16.025,21.378,16.268,20.978,16.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775131"
    },
    d: "M46.609,13.896c0.586-1.674,0.671-3.62-1.001-5.113C45.394,8.592,45.105,8.5,44.819,8.5h-1.206 c-0.992,0-1.569,1.117-0.991,1.922c0.7,0.975,1.315,2.114,1.668,3.393C44.605,14.955,46.218,15.012,46.609,13.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775131"
    },
    d: "M37.217,13.896c0.586-1.674,0.671-3.62-1.001-5.113C36.002,8.592,35.713,8.5,35.427,8.5h-1.206 c-0.992,0-1.569,1.117-0.991,1.922c0.7,0.975,1.315,2.114,1.668,3.393C35.213,14.955,36.826,15.012,37.217,13.896z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast);
export default __webpack_public_path__ + "static/media/breakfast.c48ceed5fa794f837a2e433d10906244.svg";
export { ForwardRef as ReactComponent };